import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[pioneerUppercase]'
})
export class UppercaseDirective {

  constructor(
    private control: NgControl
  ) { }

  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    this.capitalize(value);
  }

  private capitalize(value: string) {
    this.control.control.patchValue(value.toUpperCase());
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/shared/directives/uppercase.directive.ts